export class ArsenalArmyNewView {
  isLoading: boolean;
  canSubmit: boolean;

  constructor(params: ArsenalArmyNewViewParams) {
    this.isLoading = params.isLoading;
    this.canSubmit = params.canSubmit;
  }
}

export type ArsenalArmyNewViewParams = {
  isLoading: boolean;
  canSubmit: boolean;
};
